module.exports = __webpack_public_path__ + "static/media/chogath.e1a95d8d.png";